export const QuestionnaireType = {
  CERVICAL: 'ShpCervicalCancerScreening',
  KKH_TELEPAEDS: 'KkhTelePaeds',
  MAMMOGRAM: 'ShpMammogram',
  OSA: 'TRIAGE-OAS-DC-SHP_EN',
  PRE: 'SHP-Q004',
  // Doctor consultation asks the URTI question before a polyclinic is picked, so there is no
  // selected location to read QuestionnaireReference from. CCDP has no NHGP-wide questionnaire, only
  // TRIAGE-NGEMR-CON-<POLY> per polyclinic, all carrying the same question, so Ang Mo Kio's stands in
  // for NHGP. Same arrangement as OSA above, which pins one SHP polyclinic for all of SingHealth.
  URTI: 'TRIAGE-NGEMR-CON-AMK',
} as const;

export const RequestFormType = {
  Cancel: 'cancel',
  Change: 'change',
  ChangeOrCancel: 'changeorcancel',
  Make: 'make',
  FollowUp: 'followup',
} as const;
export type RequestFormTypeType = (typeof RequestFormType)[keyof typeof RequestFormType];

export const BookNextFormType = {
  Miss: 'BookMiss',
  Open: 'BookOpen',
} as const;

export const TCUMakeNewType = {
  Future: 'Future',
  Today: 'Today',
} as const;
export type TCUMakeNewTypeType = (typeof TCUMakeNewType)[keyof typeof TCUMakeNewType];

export const CervicalQuestionIds = {
  appointmentType: 'CCS-Q005',
  contactNumber: 'CCS-Q003',
  emailAddress: 'CCS-Q004',
  nric: 'CCS-Q001',
  patientName: 'CCS-Q002',
  ageCheckPapSmear: 'CCS-Q008',
  ageCheckHpvDna: 'CCS-Q009',
} as const;

export const VideoConsultProceedSteps = {
  CONTACT_DETAILS: 0,
  DELIVERY: 1,
  PAYMENT: 2,
  SUMMARY: 3,
} as const;
export type VideoConsultProceedStepsType = (typeof VideoConsultProceedSteps)[keyof typeof VideoConsultProceedSteps];

export const ServiceTypeName = {
  CervicalCancerScreening: 'Cervical Cancer Screening',
  DoctorConsultation: 'Doctor Consultation',
  HealthierSGConsult: 'Healthier@SG Consult',
  HealthPlanDiscussion: 'Health Plan Discussion',
  MammogramScreening: 'Mammogram Screening',
} as const;

export const ServiceTypeIds = {
  MammogramScreening: '113019',
  HASService: '1',
} as const;

export const MMG_OFFERING_ID = '32';

export const DentalApptDeposit = {
  ForfeitDays: 3,
} as const;

export const DentalApptDepositMessages = {
  DentalApptReschedule: 'Appointment.Message.Dental.RescheduleWithinForfeitDays',
  DentalApptCancel: 'Appointment.Message.Dental.CancelWithinForfeitDays',
  DentalApptBook: 'Appointment.Message.Dental.NewWithinForfeitDays',
} as const;

export type DentalApptDepositMessagesType = (typeof DentalApptDepositMessages)[keyof typeof DentalApptDepositMessages];

export const DoctorConsultDisclaimerMessages = {
  Nhgp: 'Appointment.DoctorConsultDisclaimer.NHGP',
  NhgpPreview: 'Appointment.DoctorConsultDisclaimer.NHGPPreview',
  Nup: 'Appointment.DoctorConsultDisclaimer.NUP',
  NupPreview: 'Appointment.DoctorConsultDisclaimer.NUPPreview',
  Shp: 'Appointment.DoctorConsultDisclaimer.SHP',
  ShpPreview: 'Appointment.DoctorConsultDisclaimer.SHPPreview',
};

export const DoctorConsultApptMessages = {
  Disclaimer: 'Appointment.DoctorConsult.Disclaimer',
  SlotsAvailability: 'Appointment.DoctorConsult.SlotsAvailability',
  SlotStatus: 'Appointment.DoctorConsult.SlotStatus',
} as const;
